import { toast } from "react-toastify";

export const REQUEST_FORM_ERRORS_SUCCESS = "REQUEST_FORM_ERRORS_SUCCESS";
export const REQUEST_FORM_ERRORS_LOADING = "REQUEST_FORM_ERRORS_LOADING";

export const formErrorLoading = (status = true) => ({
    type: REQUEST_FORM_ERRORS_LOADING,
    payload: status
});

const formErrorHandler = (error) => {
    const payload = {};

    if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        if (typeof error.response.data.error === "string") {
            payload.uncaught = [error.response.data.error];
        } else if (typeof error.response.data.errors === "string") {
            payload.uncaught = [error.response.data.errors];
        } else if (Array.isArray(error.response.data.errors)) {
            error.response.data.errors.forEach((value, index) => {
                payload[index] = Array.isArray(value) ? value : [value];
            });
        }
    } else {
        // Something happened in setting up the request that triggered an Error
        payload.uncaught = [error.message];
    }

    Object.keys(payload).forEach((key) => {
        payload[key].forEach((message) => {
            toast(message, {
                type: toast.TYPE.ERROR,
                autoClose: 3000
            });
        });
    });

    return {
        type: REQUEST_FORM_ERRORS_SUCCESS,
        payload
    };
};

export default formErrorHandler;



// WEBPACK FOOTER //
// ./src/actions/global/form-errors-handler.js